// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2d6LQ","tab":"Tabs_tab__3tIvf","tabActive":"Tabs_tabActive__2E49S"};